export const PRODUCT_FEED_MODAL = {
  TITLE: 'All Products Feed Data Test',
  BACK_BUTTON: 'Back',
  TABLE_HEADERS: {
    PRODUCT_NAME: 'Product Name',
  },
};
